import { forwardRef, Tag, TagProps } from "@chakra-ui/react";
import { MotionProps } from "framer-motion";

import MotionBox, { MotionBoxProps } from "@/common/components/MotionBox";

export function MotionFade({
  children,
  ...props
}: { children: React.ReactNode } & MotionBoxProps) {
  return (
    <MotionBox
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      transition={{ duration: 0.1, ease: "easeOut" }}
      {...props}
    >
      {children}
    </MotionBox>
  );
}

export function MotionScaleFade({
  origin = "center",
  children,
  ...props
}: {
  origin: "center" | "top" | "bottom" | "left" | "right";
  children: React.ReactNode;
} & MotionBoxProps) {
  return (
    <MotionBox
      animate={{
        opacity: 1,
        scale: 1,
      }}
      exit={{ opacity: 0, scale: 0.9 }}
      initial={{ opacity: 0, scale: 0.9 }}
      style={{
        originX: origin === "left" ? 0 : origin === "right" ? 1 : 0.5,
        originY: origin === "top" ? 0 : origin === "bottom" ? 1 : 0.5,
      }}
      transition={{ duration: 0.1, ease: "easeOut" }}
      {...props}
    >
      {children}
    </MotionBox>
  );
}

export type MotionFilterProps = TagProps & MotionProps;
export const MotionFilter = forwardRef(
  ({ children, ...props }: MotionFilterProps, ref) => {
    return (
      <Tag
        ref={ref}
        animate={{
          opacity: 1,
          scale: 1,
          transition: {
            duration: 0.05,
            type: "tween",
            ease: "circOut",
          },
        }}
        as={MotionBox}
        initial={{
          opacity: 0,
          scale: 0.9,
        }}
        style={{
          originX: 0,
          originY: 0.5,
        }}
        {...props}
      >
        {children}
      </Tag>
    );
  },
);

export function MotionRule({ children, ...props }: MotionBoxProps) {
  return (
    <MotionBox
      animate={{
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.2,
          type: "spring",
          bounce: 0.15,
        },
      }}
      initial={{
        opacity: 0,
        y: -5,
      }}
      width="full"
      {...props}
    >
      {children}
    </MotionBox>
  );
}
